import React from "react"

const factory = ({ displayName, ...factoryProps }) => {
  // create actual component
  const Component = props => {
    props = { ...factoryProps, ...props }
    // get the structural components
    const { Template, Title, Asset, Trivia, Body } = props

    return (
      <Template
        elements={{
          title: Title && <Title {...props} />,
          asset: Asset && <Asset {...props} />,
          // trivia: Trivia && <Trivia {...props} />,
          body: Body && <Body {...props} />,
        }}
        {...props}
      />
    )
  }
  Component.displayName = displayName
  return Component
}

export default factory
